"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = VariantOption;
var _react = _interopRequireDefault(require("react"));
var _Variant = _interopRequireDefault(require("./Variant.context"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Variant2 = require("./Variant.utils");
VariantOption.propTypes = {
  /** name of variant. Examples: 'b', 'c', 'mobile01234' */
  which: _propTypes.default.string.isRequired
};

// This attribute doesn't change when the file is uglified, allowing the testing in VariantSwitch to work correctly
VariantOption.uglifiedSafeName = "VariantOption";
function VariantOption(props) {
  return /*#__PURE__*/_react.default.createElement(_Variant.default.Consumer, null, variants => (0, _Variant2.doesVariantMatch)(props.which, variants) ? props.children : null);
}